import { useEffect, useState } from "react";
import { Wrench, Shirt, ClipboardList, PackageSearch, ShoppingCart, Truck, ListChecks } from "lucide-react";
import { http } from "../lib/api";
import { useList, useEqSettings } from "../components/equipment/common";
import { MaterialList } from "../components/equipment/MaterialList";
import { ItemList } from "../components/equipment/ItemList";
import { NeedList } from "../components/equipment/NeedList";
import { OrderList } from "../components/equipment/OrderList";
import { SupplierList } from "../components/equipment/SupplierList";
import { CatalogList } from "../components/equipment/CatalogList";

const TABS = [
  ["materiel", "Matériel", Wrench, "materials"], ["equipements", "Équipements", Shirt, "items"],
  ["besoins-materiel", "Besoins matériel", ClipboardList, "material_needs"], ["besoins-equipements", "Besoins équipements", PackageSearch, "equipment_needs"],
  ["commandes", "Bons de commande", ShoppingCart, "orders_open"], ["fournisseurs", "Fournisseurs", Truck], ["liste", "Liste des équipements", ListChecks],
];

export default function Materiel() {
  const [tab, setTab] = useState("materiel");
  const [settings, reloadSettings] = useEqSettings();
  const [sites, setSites] = useState([]);
  const [agents, setAgents] = useState([]);
  const [catalog, loadCatalog] = useList("/equipment/catalog");
  const [ov, setOv] = useState({});
  const loadOv = () => http.get("/equipment/overview").then((r) => setOv(r.data)).catch(() => {});
  useEffect(() => {
    http.get("/sites").then((r) => setSites(r.data)).catch(() => {});
    http.get("/agents").then((r) => setAgents((r.data || []).filter((a) => !a.archived))).catch(() => {});
    loadOv();
  }, []);
  return (
    <div className="p-6 lg:p-8 max-w-[1800px] mx-auto space-y-5" data-testid="materiel-page">
      <div>
        <h1 className="font-display text-4xl font-bold">Matériel et équipements</h1>
        <p className="text-sm text-slate-500 mt-1">Dotations des sites, équipements des agents, besoins, bons de commande et fournisseurs.</p>
      </div>
      <div className="flex flex-wrap gap-1.5 border-b border-slate-200 pb-2">
        {TABS.map(([k, l, I, c]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`eq-tab-${k}`}
            className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-semibold transition-colors ${tab === k ? "bg-[#0B2A7A] text-white" : "text-slate-600 hover:bg-slate-100"}`}>
            <I className="h-4 w-4" />{l}{c && ov[c] > 0 && <span className={`ml-1 text-[10px] px-1.5 rounded-full ${tab === k ? "bg-white/20" : "bg-amber-100 text-amber-800"}`}>{ov[c]}</span>}
          </button>
        ))}
      </div>
      {tab === "materiel" && <MaterialList sites={sites} types={settings.material_types} />}
      {tab === "equipements" && <ItemList agents={agents} catalog={catalog} />}
      {tab === "besoins-materiel" && <NeedList kind="material" sites={sites} settings={settings} onChanged={loadOv} />}
      {tab === "besoins-equipements" && <NeedList kind="equipment" agents={agents} catalog={catalog} settings={settings} onChanged={loadOv} />}
      {tab === "commandes" && <OrderList settings={settings} onChanged={loadOv} />}
      {tab === "fournisseurs" && <SupplierList />}
      {tab === "liste" && <CatalogList rows={catalog} load={loadCatalog} settings={settings} reloadSettings={reloadSettings} />}
    </div>
  );
}
